<template>
  <BaseNoticeItem>
    <template #head>
      <strong>
        {{ $t('Background Checks In Progress') }}
      </strong>
    </template>
    <template #body>
      <div>
        {{
          $t(
            'Your background checks have been initiated. You will be notified once they are complete and the contract is ready for signature. Your start date may be adjusted based on the completion of the background checks.',
          )
        }}
      </div>
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import { $t } from '@/composables/translation'
</script>
